// extracted by mini-css-extract-plugin
export default {"loadingAnimation":"Loader_loadingAnimation__mWh1P","loading-animation":"Loader_loading-animation__tEsfw"};